import { create } from 'apisauce';

const client = create({
	baseURL: 'http://apex.automate.org.in/',
	withCredentials: false,
});

export default client;
